export default __webpack_public_path__ + "static/media/navLogo.11d9ecb9.png";